import * as Enums from '../shared/utilities/enums';
import { Lesson } from '../lesson/models';

export class Section {
  Id: number;
  ModuleId: number;
  ModuleName: string;
  Ordinal: number;
  Title: string;
  Lessons: Array<Lesson>;

  constructor(obj?: any) {
    this.Id = obj && obj.Id || 0;
    this.ModuleId = obj && obj.ModuleId || 0;
    this.ModuleName = obj && obj.ModuleName || '';
    this.Ordinal = obj && obj.Ordinal || 0;
    this.Title = obj && obj.Title || '';
    this.Lessons = obj && obj.Lessons && obj.Lessons.map(t => <Array<Lesson>>(t)) || new Array<Lesson>();
  }
}

export interface IAssignment {
  IsTest: boolean;
  Id: number;
  AssignmentStatusId: number;
  LessonAssignmentId: number;
}

export class ModuleAssignment {
  Id: number;
  ModuleId: number;
  UserId: number;
  AssignmentStatusId: Enums.AssignmentStatus;
  AssignmentDate: Date;
  StartDate: Date;
  EndDate: Date;
  LastLessonIndexSeen: number;
  //LessonAssignments: Array<LessonAssignment>;
  CurrentChildAssignmentId: number;
  CurrentAssignmentIsTest: boolean;
  Assignments: Array<IAssignment>;
  TotalTime: string;
  CourseId: number;
  Ordinal: number;

  constructor(obj?: any) {
    this.Id = obj && obj.Id || 0;
    this.ModuleId = obj && obj.ModuleId || 0;
    this.UserId = obj && obj.UserId || 0;
    this.AssignmentStatusId = obj && obj.AssignmentStatusId || 0;
    this.AssignmentDate = obj && obj.AssignmentDate || null;
    this.StartDate = obj && obj.StartDate || null;
    this.EndDate = obj && obj.EndDate || null;
    this.LastLessonIndexSeen = obj && obj.LastLessonIndexSeen || 0;
    this.CurrentChildAssignmentId = obj && obj.CurrentChildAssignmentId || 0;
    this.CurrentAssignmentIsTest = obj && obj.CurrentAssignmentIsTest || false;
    this.Assignments = obj && obj.Assignments || new Array<IAssignment>();
    this.TotalTime = obj && obj.TotalTime || '';
    this.CourseId = obj && obj.CourseId || 0;
    this.Ordinal = obj && obj.Ordinal || -1;
  }
}

export class Module {
  Id: number;
  CourseId: number;
  Ordinal: number;
  Title: string;
  Sections: Array<Section>
  PercentCompleted: number;
  Status: number;
  ModuleAssignmentId: number;
  ModuleAssignment: ModuleAssignment;
  TotalTimeMinutes: number;
  LastVisited: boolean;

  constructor(obj?: any) {
    this.Id = obj && obj.Id || 0;
    this.CourseId = obj && obj.CourseId || 0;
    this.Ordinal = obj && obj.Ordinal || 0;
    this.Title = obj && obj.Title || '';
    this.Sections = obj && obj.Sections && obj.Sections.map(t => <Array<Section>>(t)) || new Array<Section>();
    this.PercentCompleted = obj && obj.PercentCompleted || 0;
    this.Status = obj && obj.Status || 0;
    this.ModuleAssignmentId = obj && obj.ModuleAssignmentId || 0;
    this.ModuleAssignment = obj && obj.ModuleAssignment && obj.ModuleAssignment.map(t => new ModuleAssignment(t)) || null;
    this.TotalTimeMinutes = obj && obj.TotalTimeMinutes || 0;
    this.LastVisited = obj && obj.LastVisited || false;
  }
}
